import {
  skeleton_styles_default
} from "./chunk.5V5RNDE3.js";
import {
  component_mobile_styles_default
} from "./chunk.3DO35SD7.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/skeleton/skeleton.styles.ts
var skeleton_styles_default2 = r` ${skeleton_styles_default} ${component_mobile_styles_default} .skeleton--square, .skeleton--circle, .skeleton--triangle, .skeleton--cross, .skeleton--comment { display: inline-flex; width: 3rem; height: 3rem; } .skeleton--square { --border-radius: var(--sl-border-radius-medium); } .skeleton--circle { --border-radius: var(--sl-border-radius-circle); } .skeleton--triangle { --border-radius: 0; clip-path: polygon(50% 0, 0 100%, 100% 100%); } .skeleton--cross { --border-radius: 0; clip-path: polygon(20% 0%, 0% 20%, 30% 50%, 0% 80%, 20% 100%, 50% 70%, 80% 100%, 100% 80%, 70% 50%, 100% 20%, 80% 0%, 50% 30%); } .skeleton--comment { --border-radius: 0; clip-path: polygon(0% 0%, 100% 0%, 100% 75%, 75% 75%, 75% 100%, 50% 75%, 0% 75%); } `;

export {
  skeleton_styles_default2 as skeleton_styles_default
};
